import { Button } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import * as XLSX from "xlsx"

function ExportToExcel({report,meters, parameters,filename,size,disable}) {

  console.log(filename)
  

const mode = useSelector((state) => state.darkMode);

const { isdarkMode } = mode;
 
  const finalReport = []
  report?.filter(re => {
    const Date = re.date
    const data = {Date}
    meters?.forEach(meter => {
      if(re[meter]){
        data[meter] = re[meter]
      }
    })
    finalReport.push(data)
  })
  const exportTo = () => {
    if (report && report.length > 0) {
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(finalReport);
  
      const now = new Date();
      const timestamp = now
        .toLocaleString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false, // Use 24-hour format
        })
        .replace(/[/,: ]/g, "-");
  
      const filename = `raw_data_report_${timestamp}.xlsx`;
  
      XLSX.utils.book_append_sheet(wb, ws, "raw_data_report");
      XLSX.writeFile(wb, filename);
    }
  };

  return (
    <div className={` ${isdarkMode ? 'exportbtn' : 'whitemode'}`}>
    <Button size={size?size:'small'} type='primary' variant="contained" defaultColor='green' onClick={exportTo}
    disabled={disable? disable:false}>
        Export to Excel
      </Button>
    </div>
  );
}

export default ExportToExcel;